import { createFileRoute } from "@tanstack/react-router";
import { CityLandingPage, buildCityLandingHead, type CityLandingConfig } from "@/components/CityLandingPage";

const CONFIG: CityLandingConfig = {
  slug: "monument",
  name: "Monument",
  region: "Tri-Lakes / El Paso County",
  heroEyebrow: "Monument Marketing Hub",
  heroTitle: { lead: "Monument marketing for ", gold: "Tri-Lakes", trail: " businesses" },
  heroDescription:
    "Monument and the Tri-Lakes area sit between Colorado Springs and Denver — high household incomes, strong school district, and buyers who choose local on principle. We build websites, SEO, and Map Pack programs for trades, professional services, and downtown Monument retail.",
  intro:
    "Monument buyers are loyal once you earn it — but they Google before they call, and they don't tolerate dated websites. Our Monument work is built for that buyer: polished, fast, proof-heavy, and unmistakably local.",
  neighborhoods: [
    "Downtown Monument",
    "Jackson Creek",
    "Woodmoor",
    "Promontory Pointe",
    "Wahsatch Springs",
    "Red Rock Ranch",
    "King's Deer",
    "Palmer Lake-adjacent",
  ],
  marketSnapshot:
    "Monument's Map Pack is regionally competitive — fewer total competitors than Colorado Springs but high-ticket categories (HVAC, roofing, custom builders) face Colorado Springs and Denver spillover. Wins come from local proof and review depth.",
  highlights: [
    {
      title: "Local-first credibility",
      body: "Monument buyers default to local. We make your local proof obvious — neighborhood photos, real reviews, no Colorado-Springs-pretending-to-be-Monument templates.",
    },
    {
      title: "Tri-Lakes service-area reach",
      body: "Most Monument businesses also serve Palmer Lake, Black Forest, and north Colorado Springs. We rank you across the real footprint.",
    },
    {
      title: "Beat the spillover on response time",
      body: "Springs and Denver shops claim Monument but respond slower. A site that signals fast local response wins the call.",
    },
  ],
  services: [
    { to: "/monument-seo", title: "Monument SEO", body: "Map Pack rankings, on-page depth, and review velocity for Tri-Lakes service areas." },
    { to: "/web-design-monument-colorado", title: "Monument Web Design", body: "Custom websites engineered for Monument's local-first buyer base — fast, polished, mobile-first." },
    { to: "/monument-geo-ai", title: "GEO / AI search", body: "Get cited in ChatGPT, Perplexity, and Google AI Overviews when Monument buyers ask AI." },
    { to: "/colorado-springs-google-maps", title: "Google Maps optimization", body: "GBP optimization, citation cleanup, and review programs that move you into the Monument 3-pack." },
  ],
  learnArticleSlugs: [
    "/learn/local-seo-guide",
    "/learn/google-business-profile",
    "/learn/website-conversion",
    "/learn/get-more-reviews",
    "/learn/marketing-budget",
    "/learn/seo-vs-ppc",
  ],
  learnIntro:
    "Monument owners win by looking unmistakably local online. These six pieces explain how to compound that advantage.",
  closingCta:
    "30-minute call. We'll audit your Monument Map Pack position, look at the Springs and Denver shops claiming your buyers, and tell you what to fix first.",
};

export const Route = createFileRoute("/monument")({
  head: () =>
    buildCityLandingHead(CONFIG, {
      metaTitle: "Monument Marketing Agency | SEO, Web Design & Maps | CWI",
      metaDescription:
        "Monument and Tri-Lakes SEO, web design, and Google Maps optimization. Local Colorado team, transparent reporting, no long-term contracts.",
    }),
  component: () => <CityLandingPage config={CONFIG} />,
});
